module.exports = {
	"Navigation": {
		"live": "Live",
		"stories": "Stories",
		"ambassadors": "Kennenlernen"
	},
	"Search": {
		"placeholder": "Ort finden",
		"errorEmpty": "Bitte geben Sie einen Ort ein.",
		"errorNotFound": "Dieser Ort wurde leider nicht gefunden."
	},
	"IndieButton": {
		"line1": "Jetzt Strom",
		"line2": "für 0 EUR",
		"line3": "sichern!"
	},
	"InfoBox": {
		"sonnenBatterie": "sonnenBatterie",
		"ambassadorSince": "Kunde seit",
		"capacity": "Kapazität",
		"autonomy": "Autarkie",
		"pvSize": "PV-Größe",
		"cta": "Mitmachen",
		"ctaAmbassador": "Termin vereinbaren",
		"disclaimer": "Bei diesem Kunden können Sie sich vor Ort von der Alltagstauglichkeit einer sonnenBatterie überzeugen."
	},
	"MasterForm": {
		"title": "Jetzt unverbindlich informieren",
		"personalInformation": "Persönliche Daten",
		"salutation": "Anrede",
		"male": "Herr",
		"female": "Frau",
		"firstname": "Vorname",
		"lastname": "Nachname",
		"email": "E-Mail",
		"phone": "Telefon",
		"energyConsumption": "Stromverbrauch pro Jahr",
		"ecPlaceholder": "in kWh",
		"subject": "Ich möchte ...",
		"sonnenBatterie": "Informationen zur sonnenBatterie",
		"sonnenCommunity": "Informationen zur sonnenCommunity",
		"pvAnlage": "Informationen zu einer PV-Anlage",
		"sonnenBotschafter": "Einen sonnenBotschafter besuchen",
		"submit": "Absenden",
		"legalNotice": "Die angegebenen Daten werden elektronisch verarbeitet und bei der sonnen GmbH verarbeitet. Die Daten werden für die Kontaktaufnahme sowie für die Zusendung von Informationsmaterial zu Produkten und Services verwendet. Mit der Absendung dieses Formulars erklären Sie sich hiermit ausdrücklich einverstanden. Die mit Sternchen gekennzeichneten Felder sind Pflichtfelder.",
		"requiredFields": "Die mit Sternchen gekennzeichneten Felder sind Pflichtfelder.",
		"gdprHeadline": "Einwilligung",
		"gdprCheckbox": "Ja, ich möchte per E-Mail, telefonisch oder durch Brief regelmäßig auf meine Bedürfnisse zugeschnittene Informationen zu neuen Produkten und Dienstleitungen der sonnen GmbH und der sonnen eServices GmbH (gemeinsam „sonnen”) erhalten. Mir ist bekannt, dass sonnen meine Daten zu diesem Zweck auch an regionale Partner von sonnen weiterleitet, die dann unmittelbar mit mir Kontakt aufnehmen werden. Ich kann diese Einwilligung jederzeit für die Zukunft widerrufen, indem ich die Übermittlung von Informationen über die Website von sonnen abbestelle, oder den Widerruf per E-Mail, per Fax oder postalisch an die im Impressum angegebenen Kontaktdaten sende.",
		"successMessage": "Danke für ihr Interesse. Wir haben Ihnen soeben eine E-Mail zugesandt. Um Ihre Anfrage abzuschließen, klicken Sie bitte auf den Bestätigungslink in der E-Mail.",
		"errorMessage": "Leider konnte ihre Anfrage im Moment nicht verarbeitet werden. Bitte versuchen Sie es später noch einmal."
	},
	"Footer": {
		"imprint": "Impressum",
		"privacy": "Datenschutz"
	}
};


// WEBPACK FOOTER //
// ./src/i18n/de.json